import React from 'react'
import {
  MetricCard,
  MetricCardHeader,
  MetricIcon,
  MetricTitle,
  MetricValuesContainer,
  MetricValueItem,
  MetricValueLabel,
  MetricValueNumber,
} from './styles'

const MetricCardComponent = ({ icon, text, totalValue, activeValue, color, onCardClick, clicked }) => {
  const handleCardClick = () => {
    const cardType = text.toLowerCase().includes('corporate') ? 'corporate' : 
                    text.toLowerCase().includes('institute') ? 'institute' : 
                    text.toLowerCase().includes('admin') ? 'admin' :
                    text.toLowerCase().includes('student') ? 'student' : null
    onCardClick(cardType, activeValue)
  }

  return (
    <MetricCard 
      onClick={handleCardClick}
      style={{ cursor: 'pointer' }}
      clicked={clicked}
    >
      <MetricCardHeader>
        <MetricIcon color={color}>
          {icon}
        </MetricIcon>
        <MetricTitle>{text}</MetricTitle>
      </MetricCardHeader>
      <MetricValuesContainer>
        <MetricValueItem>
          <MetricValueLabel>Total:</MetricValueLabel>
          <MetricValueNumber>{totalValue.toLocaleString()}</MetricValueNumber>
        </MetricValueItem>
        <MetricValueItem>
          <MetricValueLabel>Online:</MetricValueLabel>
          <MetricValueNumber>{activeValue.toLocaleString()}</MetricValueNumber>
        </MetricValueItem>
      </MetricValuesContainer>
    </MetricCard>
  )
}

export default MetricCardComponent
